<template>
  <!-- "Chris says you're a Pisces, born March 3." (recipient journey R6.4):
       the sender's guess, offered to the recipient alone. Confirming is one
       tap, writes the date only, and is the only way it becomes hers; "No"
       just moves on to asking her. -->
  <div v-if="suggested" class="sb" data-testid="suggested-birthday">
    <p class="sb-line">{{ line }}</p>
    <div class="sb-actions">
      <button type="button" class="sb-yes" data-testid="suggested-yes" :disabled="busy" @click="yes">Yes, that's me</button>
      <button type="button" class="sb-no" data-testid="suggested-no" :disabled="busy" @click="$emit('declined')">No</button>
    </div>
    <p v-if="err" class="sb-err">{{ err }}</p>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { getSuggestedBirthday, confirmSuggestedBirthday } from '@/api-service'
import { suggestedLine } from '@/utils/stage-three'

const props = defineProps({ inv: { type: String, required: true } })
const emit = defineEmits(['confirmed', 'declined', 'none'])

const suggested = ref(null)
const busy = ref(false)
const err = ref('')

const line = computed(() => (suggested.value ? suggestedLine(suggested.value) : ''))

onMounted(async () => {
  try { suggested.value = await getSuggestedBirthday(props.inv) } catch (e) { suggested.value = null }
  if (!suggested.value) emit('none')
})

async function yes() {
  busy.value = true; err.value = ''
  try {
    const r = await confirmSuggestedBirthday(props.inv)
    emit('confirmed', r && r.moment)
  } catch (e) {
    err.value = 'That did not save. Try again.'
  } finally { busy.value = false }
}
</script>

<style scoped>
.sb { background: rgba(20,7,31,0.92); border: 1px solid rgba(240,217,163,0.22); border-radius: 14px; padding: 14px; color: #e9dcff; }
.sb-line { margin: 0; font-size: 14.5px; line-height: 1.5; }
.sb-line b { color: #f0d9a3; }
.sb-actions { display: flex; gap: 10px; margin-top: 12px; flex-wrap: wrap; }
.sb-yes { background: linear-gradient(180deg, #7b4bb0, #4e2776); color: #fff; border: none; border-radius: 999px;
  padding: 10px 20px; min-height: 44px; font-weight: 700; cursor: pointer; font-family: inherit; }
.sb-no { background: transparent; color: #9b86c9; border: 1px solid rgba(155,134,201,0.4); border-radius: 999px;
  padding: 10px 18px; min-height: 44px; cursor: pointer; font-family: inherit; }
.sb-err { color: #f0a3a3; font-size: 12px; margin: 8px 0 0; }
</style>
